import { render } from "./006-VRMusicPage.vue?vue&type=template&id=28a5c59b&scoped=true"
import script from "./006-VRMusicPage.vue?vue&type=script&lang=js"
export * from "./006-VRMusicPage.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=28a5c59b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a5c59b"]])

export default __exports__